<template>

  <div
    class="bullet"
    :class="status">
  </div>

</template>

<script>
export default {
  name: 'PointStatus',
  props: [
    'status'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bullet{
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: #8aa2ad;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
}
  .bullet.open{
    background: #4fc510;
  }
  .bullet.analyzing{
    background: #ffc107;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/PointStatus.vue